import Api from '@/api/rest/ProjectStatisticApi';

export default new Api();
